export class Unidad {
    descripcion: string;
    esCasinoByEnjoy: boolean;
    esHotel: boolean;
    esHotelByEnjoy: boolean;
    idUnidad: number;
    idIdioma: number;
    idioma: string;
    nombre: string;
    pathImagen: string;
    linkMap: string;


    constructor() {
        this.descripcion = '';
        this.esCasinoByEnjoy = false;
        this.esHotel = false;
        this.esHotelByEnjoy = false;
        this.idIdioma = 0;
        this.idUnidad = 0;
        this.idioma = '';
        this.nombre = '';
        this.pathImagen = '';
        this.linkMap = '';
    }
}